import React from 'react';
import './App.css';
import axios from 'axios';
function App() {
  const [err, seterr] = React.useState({
    status:false,
    errbg:"",
    text:""
  })
  const [contact, setContact] = React.useState({
    name:'',
    email:'',
    phone:'',
    subject:'',
    message:''

  })

  const ChangeHandle = (e)=>{
    const {name,value} = e.target
    setContact({
      ...contact,
      [name]:value
    })
  }

   const contactsubmit = (e)=>{
   e.preventDefault()
    if(contact.email!="" && contact.name!="" && contact.phone!="" && contact.subject!="" && contact.message!="" ){
      
    
      axios({
        method: "post",
        url: "https://softmeck.com/api/EyeDev/Contact",
        data:JSON.stringify(
          {
            email:contact.email,
            name:contact.name,
            phone:contact.phone,
            subject:contact.subject,
            message:contact.message
          }
        ),
        headers: { 
            "Content-Type": "application/json",
            "accesskey":"v2T1DoTrPwNenFSBY0NNS3NWnLcrIVP8",
            
         },
      })
        .then(function (response) {
       
          if(response.data.fire==true){
          
           
            seterr({
              status:true,
              errbg:"bg-success",
              text:"you Messgae has been Sent."
            })
            setContact({
              name:''
         
            })
            e.target.reset()
          }
          
        })
        .catch(function (response) {
          //handle error
          console.log(response);
    })
    }
    else{
      seterr({
        status:true,
        errbg:"bg-danger",
        text:"Please Fill All Required Fields."
      })
      setTimeout(() => {
        seterr({status:false})
      }, 2000);
    }
   }

  return (

  <div>
  
 
 
	<header class="header-pr nav-bg-w main-header navfix fixed-top menu-dark">
		<div class="container-fluid m-pad">
			<div class="menu-header">
				<div class="dsk-logo"><a class="nav-brand" href="index.html">
					<img src="asset/images/white-logo.png" alt="Logo" class="mega-white-logo"/>
					<img src="asset/images/logo.png" alt="Logo" class="mega-darks-logo"/>
				</a></div>
				<div class="custom-nav" role="navigation">
					<ul class="nav-list onepge">
						<li><a href="#home" class="menu-links">Home</a></li>					
						<li><a href="#about" class="menu-links">About</a></li>
						<li><a href="#services" class="menu-links">Services</a></li>
						<li><a href="#work" class="menu-links">Work</a></li>						
						{/* <li><a href="#client" class="menu-links">Clients</a></li>
						<li><a href="#review" class="menu-links">Review</a></li> */}
						<li><a href="#contact" class="btn-br bg-btn5 btshad-b2 lnk">Contact Us <span class="circle"></span></a> </li>
					</ul>
				</div>
				<div class="mobile-menu2">
					<ul class="mob-nav2">
	
					</ul>
				</div>
			</div>

			<nav id="main-nav">
				<ul class="first-nav">
					<li><a href="#home" class="menu-links">Home</a></li>					
						<li><a href="#about" class="menu-links">About</a></li>
						<li><a href="#services" class="menu-links">Services</a></li>
						<li><a href="#work" class="menu-links">Work</a></li>						
						{/* <li><a href="#client" class="menu-links">Clients</a></li>
						<li><a href="#review" class="menu-links">Review</a></li> */}
				</ul>
				<ul class="bottom-nav">
					<li class="prb">
						<a href="tel:+11111111111">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384">
								<path d="M353.188,252.052c-23.51,0-46.594-3.677-68.469-10.906c-10.719-3.656-23.896-0.302-30.438,6.417l-43.177,32.594
								c-50.073-26.729-80.917-57.563-107.281-107.26l31.635-42.052c8.219-8.208,11.167-20.198,7.635-31.448
								c-7.26-21.99-10.948-45.063-10.948-68.583C132.146,13.823,118.323,0,101.333,0H30.813C13.823,0,0,13.823,0,30.813
								C0,225.563,158.438,384,353.188,384c16.99,0,30.813-13.823,30.813-30.813v-70.323C384,265.875,370.177,252.052,353.188,252.052z"
								/>
							</svg>
						</a>
					</li>
					<li class="prb">
						<a href="https://separateweb.com/cdn-cgi/l/email-protection#b4c7dbd9d1c3d1d6d9d1d0ddd5f4d3d9d5ddd89ad7dbd9">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
						</a>
					</li>
					<li class="prb">
						<a href="skype:niwax.company?call">
							<svg enable-background="new 0 0 24 24" height="18" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg"><path d="m23.309 14.547c1.738-7.81-5.104-14.905-13.139-13.543-4.362-2.707-10.17.352-10.17 5.542 0 1.207.333 2.337.912 3.311-1.615 7.828 5.283 14.821 13.311 13.366 5.675 3.001 11.946-2.984 9.086-8.676zm-7.638 4.71c-2.108.867-5.577.872-7.676-.227-2.993-1.596-3.525-5.189-.943-5.189 1.946 0 1.33 2.269 3.295 3.194.902.417 2.841.46 3.968-.3 1.113-.745 1.011-1.917.406-2.477-1.603-1.48-6.19-.892-8.287-3.483-.911-1.124-1.083-3.107.037-4.545 1.952-2.512 7.68-2.665 10.143-.768 2.274 1.76 1.66 4.096-.175 4.096-2.207 0-1.047-2.888-4.61-2.888-2.583 0-3.599 1.837-1.78 2.731 2.466 1.225 8.75.816 8.75 5.603-.005 1.992-1.226 3.477-3.128 4.253z"/></svg>
						</a>
					</li>
				</ul>
			</nav>					
		</div>
	</header>
	
  
  <div class="popup-modal1">
    <div class="modal" id="menu-popup">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="common-heading">
              <h4 class="mt0 mb0">Write a Message</h4>
            </div>
            <button type="button" class="closes" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <div class="form-block fdgn2 mt10 mb10">
              <form action="#" method="post" name="feedback-form">
                <div class="fieldsets row">
                  <div class="col-md-12"><input type="text" placeholder="Full Name" name="name" /></div>
                  <div class="col-md-12"><input type="email" placeholder="Email Address" name="email" /></div>
                  <div class="col-md-12"><input type="number" placeholder="Contact Number" name="phone" /></div>
                  <div class="col-md-12"><input type="text" placeholder="Subject" name="subject" /></div>
                  <div class="col-md-12"><textarea placeholder="Message" name="message"></textarea></div>
                </div>
                <div class="fieldsets mt20 pb20">
                  <button type="submit" name="submit" class="lnk btn-main bg-btn" data-dismiss="modal">Submit <i
                      class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="hero-section hero-bg-bg1 bg-gradient web-deg" id="home">
    <div class="text-block">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 v-center">
            <div class="header-heading">
              <h1 class="wow fadeInUp" data-wow-delay=".2s">Creative Software Development Company</h1>
              <p class="wow fadeInUp" data-wow-delay=".4s">WE PROVIDE CREATIVE, INNOVATIVE, AND PROFESSIONAL SERVICES FOR WEB DEVELOPMENT....</p>
              <a href="#about" class="btn-main bg-btn lnk wow fadeInUp" data-wow-delay=".6s">Read More <i
                  class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></a>
            </div>
          </div>
          <div class="col-lg-6 v-center">
            <div class="single-image wow fadeIn" data-wow-delay=".5s">
              <img src="asset/images/hero/digital-marketing.png" alt="web development" class="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="about-agency pad-tb" id="about">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 v-center">
          <div class="image-block">
            <img src="asset/images/service/digitalmarketing.png" alt="about" class="img-fluid no-shadow" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="common-heading text-l">
            <span>Leading the new Digital World</span>
            <h2>About Agency</h2>
            <p>WE PROVIDE CREATIVE, INNOVATIVE, AND PROFESSIONAL SERVICES FOR WEB DEVELOPMENT. HAVING A TEAM OF EXPERT DESIGNERS PROFESSIONAL WEB DEVELOPERS THAT CAN DRIVE YOUR BUSINESS TOWARDS THE DESIRED DESTINATION AND TAKE YOU WHERE YOU WANT. WE HAVE LEARNED THAT THE GREAT DESIGNS ARE TEAMWORK AT ONCE; IT NEEDS PATIENCE, EFFECTIVE TEAMWORK, AND CREATIVITY TO BRING SOMETHING THAT IS JUST AWESOME!. </p>
            <p class="quote">We try best, and we make sure we deliver best.</p>
            <div class="user- mt30">
              <div class="media">
                <div class="user-image bdr-radius"><img src="asset/images/ahmed.jpg" alt="girl"
                    style={{ width:'100px' , height:'100px' }} /></div>
                <div class="media-body user-info v-center">
                  <h5>Ahmed Ali</h5>
                  <p>Founder of <span>EyeDev</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="service-section web-servic pad-tb" id="services">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="common-heading">
            <span>Services We’re Provided</span>
            <h2 class="mb30 " >Our Software Development Services</h2>
          </div>
        </div>
      </div>
      <div class="row upset link-hover shape-num justify-content-center">
        <div class="colg-lg-5 col-sm-6 mt30 shape-loc wow fadeInUp" data-wow-delay="0.2s">
          <div class="s-block" data-tilt data-tilt-max="5" data-tilt-speed="1000">
            <div class="s-card-icon"><img src="asset/images/icons/branding.svg" alt="service" class="img-fluid" /></div>
            <h4>Logo & Branding Service</h4>
            <p>As you know every business or website should most have an attractive logo or banner to become a brand in the digital era so EyeDev has decided to give their customers also graphics designing services. In this service, you can hire us for your branding, social media post designing, and much more with different prices depending on what level of experience you are looking at! You will choose a graphic design studio that is perfect for you too by using the Google Adsense program as we would supply logos & banners which could be displayed everywhere including print stores etc. </p>
         
          </div>
        </div>
        <div class="colg-lg-5 col-sm-6 mt30 shape-loc wow fadeInUp" data-wow-delay="0.4s">
          <div class="s-block" data-tilt data-tilt-max="5" data-tilt-speed="1000">
            <div class="s-card-icon"><img src="asset/images/icons/development.svg" alt="service" class="img-fluid" /></div>
            <h4>Website Design & Development</h4>
            <p>We keep ourselves updated with the latest trends of Website Development around the globe and we understand its needs and also what value we can add to these trends. Thus, we are serving the global market with our best solutions of Frontend Development as per your demand and paving an online way to your success in business.</p>
            <p class="mt-5">In today’s digital world, your website is the first interaction consumers have with your business.</p>
          
          </div>
        </div>
        <div class="colg-lg-5 col-sm-6 mt30 shape-loc wow fadeInUp" data-wow-delay="0.6s">
          <div class="s-block" data-tilt data-tilt-max="5" data-tilt-speed="1000">
            <div class="s-card-icon"><img src="asset/images/icons/app.svg" alt="service" class="img-fluid" /></div>
            <h4>Mobile App Development</h4>
            <p>Using solid expertise in mobile apps development, our team will help you create practical and seamless experiences on any device and get the best of mobile technology for your business. We provide full-cycle mobile app development services. This includes expert business analysis, design, and development of your mobile application from idea to launch, integrating the new product into your infrastructure, and providing further optimization and scale-up on demand.</p>
    
          </div>
        </div>
        <div class="colg-lg-5 col-sm-6 mt30 shape-loc wow fadeInUp" data-wow-delay="0.8s">
          <div class="s-block mb0" data-tilt data-tilt-max="5" data-tilt-speed="1000">
            <div class="s-card-icon"><img src="asset/images/icons/marketing.svg" alt="service" class="img-fluid" /></div>
            <h4>Digital Marketing Service</h4>
            <p class="mt-3" ></p>
            <p>With digital marketing, your business can expand into new areas, hire additional team members, and achieve tremendous accomplishments in your industry. Thanks to social media and review sites like Yelp, you can build a great online reputation fast. Our team researched and reviewed thousands of digital marketing services, and came up with the ones we think are best for both businesses and individuals.</p>
            
   
          </div>
        </div>
      </div>
      <div class="-cta-btn mt70">
        <div class="free-cta-title v-center wow zoomInDown" data-wow-delay=".9s">
          <p>Hire a <span>Dedicated Developer</span></p>
          <a href="https://www.fiverr.com/eyedev" target="_blank" class="btn-main bg-btn2 lnk">Hire Now<i class="fas fa-chevron-right fa-icon"></i><span
              class="circle"></span></a>
        </div>
      </div>
    </div>
  </section>
 
  <div class="statistics-section bg-gradient pad-tb tilt3d">
    <div class="container">
      <div class="row justify-content-center t-ctr">
        <div class="col-lg-4 col-sm-6">
          <div class="statistics">
            <div data-tilt data-tilt-max="20" data-tilt-speed="1000" class="statistics-img">
              <img src="asset/images/icons/startup.svg" alt="years" class="img-fluid" />
            </div>
            <div class="statnumb">
              <span class="counter">4</span><span>+</span>
              <p>Year In Business</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6">
          <div class="statistics">
            <div data-tilt data-tilt-max="20" data-tilt-speed="1000" class="statistics-img">
              <img src="asset/images/icons/team.svg" alt="team" class="img-fluid" />
            </div>
            <div class="statnumb">
              <span class="counter">10</span><span>+</span>
              <p>Team Members</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row small t-ctr justify-content-center">
        <div class="col-lg-3 col-sm-6">
          <div class="statistics">
            <div data-tilt data-tilt-max="20" data-tilt-speed="1000" class="statistics-img">
              <img src="asset/images/icons/deal.svg" alt="happy" class="img-fluid" />
            </div>
            <div class="statnumb">
              <span class="counter">250</span>
              <p>Happy Clients</p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="statistics">
            <div data-tilt data-tilt-max="20" data-tilt-speed="1000" class="statistics-img">
              <img src="asset/images/icons/computers.svg" alt="project" class="img-fluid" />
            </div>
            <div class="statnumb counter-number">
              <span class="counter">300</span><span></span>
              <p>Local Projects Done</p>
            </div>
          </div>
        </div>
      
        <div class="col-lg-3 col-sm-6">
          <div class="statistics mb0">
            <div data-tilt data-tilt-max="20" data-tilt-speed="1000" class="statistics-img">
              <img src="asset/images/icons/customer-service.svg" alt="support" class="img-fluid" />
            </div>
            <div class="statnumb">
              <span>12H<small>rs</small></span>
              <p>Support Available</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="portfolio-section pad-tb" id="work">
    <div class="container">
      <div class="row justify-content-center ">
        <div class="col-lg-8">
          <div class="common-heading">
            <span>Our Work</span>
            <h2 class="mb0">Our Latest Work</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-sm-12 mt60 wow fadeInUp" data-wow-delay="0.2s">
          <div class="isotope_item hover-scale">
            <div class="item-image" data-tilt data-tilt-max="2" data-tilt-speed="1000">
              <a href="#"><img src="asset/img/msm.jpg" alt="image" class="img-fluid" /> </a>
            </div>
            <div class="item-info">
              <h4><a href="#">Amusment Park</a></h4>
              <p>Web Page</p>
            </div>
          </div>
        </div>
      
        <div class="col-lg-6 col-sm-12 mt60 wow fadeInUp" data-wow-delay="0.8s">
          <div class="isotope_item hover-scale">
            <div class="item-image" data-tilt data-tilt-max="2" data-tilt-speed="1000">
              <a href="#"><img src="asset/img/pes.jpg" alt="image" class="img-fluid" /> </a>
            </div>
            <div class="item-info">
              <h4><a href="#">Pakistan Esport </a></h4>
              <p>Web Application <small>(React)</small></p>
            </div>
          </div>
        </div>


        <div class="col-lg-6 col-sm-12 mt60 wow fadeInUp" data-wow-delay="0.2s">
          <div class="isotope_item hover-scale">
            <div class="item-image" data-tilt data-tilt-max="2" data-tilt-speed="1000">
              <a href="#"><img src="asset/img/portal.jpg" alt="image" class="img-fluid" /> </a>
            </div>
            <div class="item-info">
              <h4><a href="#">Movies Portal</a></h4>
              <p>Web Application</p>
            </div>
          </div>
        </div>
      
        <div class="col-lg-6 col-sm-12 mt60 wow fadeInUp" data-wow-delay="0.8s">
          <div class="isotope_item hover-scale">
            <div class="item-image" data-tilt data-tilt-max="2" data-tilt-speed="1000">
              <a href="#"><img src="asset/img/lawyer.jpg" alt="image" class="img-fluid" /> </a>
            </div>
            <div class="item-info">
              <h4><a href="#">Lawyer Community </a></h4>
              <p>Web Application </p>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-sm-12 mt60 wow fadeInUp" data-wow-delay="0.2s">
          <div class="isotope_item hover-scale">
            <div class="item-image" data-tilt data-tilt-max="2" data-tilt-speed="1000">
              <a href="#"><img src="asset/img/ais2.jpg" alt="image" class="img-fluid" /> </a>
            </div>
            <div class="item-info">
              <h4><a href="#">Internet Service Erp</a></h4>
              <p>Web Application</p>
            </div>
          </div>
        </div>
      
        <div class="col-lg-6 col-sm-12 mt60 wow fadeInUp" data-wow-delay="0.8s">
          <div class="isotope_item hover-scale">
            <div class="item-image" data-tilt data-tilt-max="2" data-tilt-speed="1000">
              <a href="#"><img src="asset/img/branet.jpg" alt="image" class="img-fluid" /> </a>
            </div>
            <div class="item-info">
              <h4><a href="#">Breanet Business ERP </a></h4>
              <p>Web Application </p>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-sm-12 mt60 wow fadeInUp" data-wow-delay="0.8s">
          <div class="isotope_item hover-scale">
            <div class="item-image" data-tilt data-tilt-max="2" data-tilt-speed="1000">
              <a href="#"><img src="asset/img/softmeck.jpg" alt="image" class="img-fluid" /> </a>
            </div>
            <div class="item-info">
              <h4><a href="#">softmeck.com </a></h4>
              <p>Web Application </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  {/* <section class="clients-section pad-tb" id="client">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="common-heading">
            <span>Our happy customers</span>
            <h2>Some of our Clients</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="opl">
            <ul>
              <li class=" wow fadeIn" data-wow-delay=".2s">
                <div class="clients-logo"><img src="asset/images/client/clients-1.png" alt="text" class="img-fluid" /></div>
              </li>
              <li class=" wow fadeIn" data-wow-delay=".4s">
                <div class="clients-logo"><img src="asset/images/client/clients-2.png" alt="text" class="img-fluid" /></div>
              </li>
              <li class=" wow fadeIn" data-wow-delay=".6s">
                <div class="clients-logo"><img src="asset/images/client/clients-3.png" alt="text" class="img-fluid" /></div>
              </li>
              <li class=" wow fadeIn" data-wow-delay=".8s">
                <div class="clients-logo"><img src="asset/images/client/clients-4.png" alt="text" class="img-fluid" /></div>
              </li>
              <li class=" wow fadeIn" data-wow-delay="1s">
                <div class="clients-logo"><img src="asset/images/client/clients-5.png" alt="text" class="img-fluid" /></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="-cta-btn mt70">
        <div class="free-cta-title v-center wow zoomInDown" data-wow-delay="1.2s">
          <p>We <span>Promise.</span> We <span>Deliver.</span></p>
          <a href="#" class="btn-main bg-btn2 lnk">Let's Work Together<i class="fas fa-chevron-right fa-icon"></i><span
              class="circle"></span></a>
        </div>
      </div>
    </div>
  </section>
  */}
  <section class="work-category pad-tb tilt3d">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 v-center">
          <div class="common-heading text-l">
            <span>Industries we work for</span>
            <h2>Helping Businesses in All Domains</h2>
            <p>We consider our customers & associates as our business partners, thus enabling us to overcome the challenges with cost-effective solutions.</p>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="work-card-set">
            <div class="icon-set wow fadeIn" data-wow-delay=".2s">
              <div class="work-card cd1">
                <div class="icon-bg"><img src="asset/images/icons/icon-1.png" alt="Industries" /></div>
                <p>Social Networking</p>
              </div>
            </div>
            <div class="icon-set wow fadeIn" data-wow-delay=".4s">
              <div class="work-card cd2">
                <div class="icon-bg"><img src="asset/images/icons/icon-2.png" alt="Industries" /></div>
                <p>Digital Marketing</p>
              </div>
            </div>
            <div class="icon-set wow fadeIn" data-wow-delay=".6s">
              <div class="work-card cd3">
                <div class="icon-bg"><img src="asset/images/icons/icon-3.png" alt="Industries" /></div>
                <p>Ecommerce Development</p>
              </div>
            </div>
            <div class="icon-set wow fadeIn" data-wow-delay=".8s">
              <div class="work-card cd4">
                <div class="icon-bg"><img src="asset/images/icons/icon-4.png" alt="Industries" /></div>
                <p>Video Service</p>
              </div>
            </div>
            <div class="icon-set wow fadeIn" data-wow-delay="1s">
              <div class="work-card cd5">
                <div class="icon-bg"><img src="asset/images/icons/icon-5.png" alt="Industries" /></div>
                <p>Banking Service</p>
              </div>
            </div>
            <div class="icon-set wow fadeIn" data-wow-delay="1.2s">
              <div class="work-card cd6">
                <div class="icon-bg"><img src="asset/images/icons/icon-6.png" alt="Industries" /></div>
                <p>Enterprise Service</p>
              </div>
            </div>
            <div class="icon-set wow fadeIn" data-wow-delay="1.4s">
              <div class="work-card cd7">
                <div class="icon-bg"><img src="asset/images/icons/icon-7.png" alt="Industries" /></div>
                <p>Education Service</p>
              </div>
            </div>
            <div class="icon-set wow fadeIn" data-wow-delay="1.6s">
              <div class="work-card cd8">
                <div class="icon-bg"><img src="asset/images/icons/icon-8.png" alt="Industries" /></div>
                <p>Tour and Travels</p>
              </div>
            </div>
            <div class="icon-set wow fadeIn" data-wow-delay="1.8s">
              <div class="work-card cd9">
                <div class="icon-bg"><img src="asset/images/icons/icon-9.png" alt="Industries" /></div>
                <p>Health Service</p>
              </div>
            </div>
            <div class="icon-set wow fadeIn" data-wow-delay="2s">
              <div class="work-card cd10">
                <div class="icon-bg"><img src="asset/images/icons/icon-10.png" alt="Industries" /></div>
                <p>Event & Ticket</p>
              </div>
            </div>
            <div class="icon-set wow fadeIn" data-wow-delay="2.2s">
              <div class="work-card cd11">
                <div class="icon-bg"><img src="asset/images/icons/icon-11.png" alt="Industries" /></div>
                <p>Restaurant Service</p>
              </div>
            </div>
            <div class="icon-set wow fadeIn" data-wow-delay="2.4s">
              <div class="work-card cd12">
                <div class="icon-bg"><img src="asset/images/icons/icon-12.png" alt="Industries" /></div>
                <p>Business Consultant</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
 
  {/* <section class="testinomial-section pad-tb" id="review">
    <div class="container">
      <div class="row">
        <div class="col-lg-5 v-center">
          <div class="common-heading text-l">
            <span>Clients Testimonial</span>
            <h2 class="mb0">What our clients say about our Company.</h2>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="owl-carousel testimonial-card-a pl25">
            <div class="testimonial-card">
              <div class="t-text">
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type
                  specimen book. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
                  has been the industry's standard dummy text ever since.</p>
              </div>
              <div class="client-thumbs mt30">
                <div class="media v-center">
                  <div class="user-image bdr-radius"><img src="asset/images/user-thumb/girl.jpg" alt="girl"
                      class="img-fluid" /></div>
                  <div class="media-body user-info v-center">
                    <h5>Moana Smile</h5>
                    <p>CEO of Niwax, <small>Jaipur, India</small></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="testimonial-card">
              <div class="t-text">
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type
                  specimen book. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
                  has been the industry's standard dummy text ever since.</p>
              </div>
              <div class="client-thumbs mt30">
                <div class="media v-center">
                  <div class="user-image bdr-radius"><img src="asset/images/user-thumb/girl.jpg" alt="girl"
                      class="img-fluid" /></div>
                  <div class="media-body user-info">
                    <h5>Moana Smile</h5>
                    <p>CEO of Niwax, <small>Jaipur, India</small></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="testimonial-card">
              <div class="t-text">
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type
                  specimen book. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
                  has been the industry's standard dummy text ever since.</p>
              </div>
              <div class="client-thumbs mt30">
                <div class="media v-center">
                  <div class="user-image bdr-radius"><img src="asset/images/user-thumb/girl.jpg" alt="girl"
                      class="img-fluid" /></div>
                  <div class="media-body user-info">
                    <h5>Moana Smile</h5>
                    <p>CEO of Niwax, <small>Jaipur, India</small></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> */}

  <section class="enquire-form pad-tb" id="contact">
    <div class="container">
      <div class="row light-bgs">
        <div class="col-lg-6">
          <div class="common-heading text-l">
            <span>Contact Now</span>
            <h2 class="mt0">Have Question? Write a Message</h2>
          </div>
          
          {err.status?<div class={"alert  text-light  alert-dismissible fade show py-3 "+err.errbg}>
         
        {err.text}
         </div>:''}

          <div class="form-block">

            <form action="#" method="post" onSubmit={contactsubmit}  >
              <div class="fieldsets row">
                <div class="col-md-6"><input type="text" onChange={ChangeHandle} value={contact.name} placeholder="Full Name" name="name"/></div>
                <div class="col-md-6"><input type="email" onChange={ChangeHandle} value={contact.email}  placeholder="Email Address" name="email"/></div>
              </div>
              <div class="fieldsets row">
                <div class="col-md-6"><input type="number" onChange={ChangeHandle} value={contact.phone}  placeholder="Contact Number" name="phone"/></div>
                <div class="col-md-6"><input type="text" onChange={ChangeHandle} value={contact.subject}  placeholder="Subject" name="subject"/></div>
              </div>
              <div class="fieldsets"><textarea onChange={ChangeHandle} placeholder="Message" name="message">{contact.message}</textarea></div>
             
              <div class="fieldsets mt20"> <button type="submit"  class="lnk btn-main bg-btn">Submit <i
                    class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></button> </div>
              <p class="trm"><i class="fas fa-lock"></i>We hate spam, and we respect your privacy.</p>
            </form>
          </div>
        </div>
        <div class="col-lg-6 v-center">
          <div class="enquire-image">
            <img src="asset/images/about/hellopic.png" alt="enquire" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </section>
 
  {/* <section class="our-office pad-tb">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="common-heading">
            <span>Our Locations</span>
            <h2>Our office</h2>
          </div>
        </div>
      </div>
      <div class="row justify-content-center upset shape-numm">
        <div class="col-lg-4 col-sm-6 shape-loc wow fadeInUp" data-wow-delay=".2s">
          <div class="office-card">
            <div class="skyline-img" data-tilt data-tilt-max="4" data-tilt-speed="1000">
              <img src="asset/images/location/newyork.png" alt="New York" class="img-fluid" />
            </div>
            <div class="office-text">
              <h4>New York</h4>
              <p>603 FA Forest Avenue, New York, USA 10021</p>
              <a href="javascript:void(0)" target="blank" class="btn-outline">View on Map <i
                  class="fas fa-chevron-right fa-icon"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 shape-loc wow fadeInUp" data-wow-delay=".4s">
          <div class="office-card">
            <div class="skyline-img" data-tilt data-tilt-max="4" data-tilt-speed="1000">
              <img src="asset/images/location/sydeny.png" alt="sydney" class="img-fluid" />
            </div>
            <div class="office-text">
              <h4>Sydney</h4>
              <p>2449 Columbia Boulevard, Sydney, 10021</p>
              <a href="javascript:void(0)" target="blank" class="btn-outline">View on Map <i
                  class="fas fa-chevron-right fa-icon"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 shape-loc wow fadeInUp" data-wow-delay=".6s">
          <div class="office-card mb0">
            <div class="skyline-img" data-tilt data-tilt-max="4" data-tilt-speed="1000">
              <img src="asset/images/location/rome.png" alt="rome" class="img-fluid" />
            </div>
            <div class="office-text">
              <h4>Rome</h4>
              <p>9988 Piazzetta Scalette Rubiani 99, Rome, 84090</p>
              <a href="javascript:void(0)" target="blank" class="btn-outline">View on Map <i
                  class="fas fa-chevron-right fa-icon"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> */}

  <footer>
    {/* <div class="footer-row1">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="email-subs">
              <h3>Get New Insights Weekly</h3>
              <p>News letter dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt. Enter your
                email</p>
            </div>
          </div>
          <div class="col-lg-6 v-center">
            <div class="email-subs-form">
              <form>
                <input type="email" placeholder="Email Your Address" name="emails"/>
                <button type="submit" name="submit" class="lnk btn-main bg-btn">Subscribe <i
                    class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div> */}
    <div class="footer-row2">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-lg-3 col-sm-6  ftr-brand-pp">
            <a class="navbar-brand mt30   " href="#"> <img src="asset/images/logo.png" alt="Logo" style={{width:'250px'}} /></a>
            <p>WE PROVIDE CREATIVE, INNOVATIVE, AND PROFESSIONAL SERVICES FOR WEB DEVELOPMENT.</p>
            <div class="container-fluid" style={{padding:0}}>
              <div class="row" style={{padding:0}}>
                <div class='col-lg-6' style={{padding:0}} >
                <a style={{width:'98%',borderRadius:0,marginLeft:"1%"}} href="https://www.fiverr.com/eyedev" target='_blank' class="btn-main bg-btn2 lnk mt-3">Fiverr <i
                class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></a>
              
                </div>
                <div class='col-lg-6' style={{padding:0}} >
               
                <a style={{width:'98%',borderRadius:0,marginLeft:"1%"}} href="#" target='_blank' class="btn-main bg-btn3 lnk  mt-3">Upwork <i
                class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></a>
                </div>
              </div>
            </div>
          </div>
          
          <div>
        
          </div>
          <div class="col-lg-3 col-sm-6">
            <h5>Contact Us</h5>
            <ul class="footer-address-list ftr-details">
              <li>
                <span><i class="fas fa-envelope"></i></span>
                <p>Email <span>workwitheyedev@gmail.com</span>
                </p>
              </li>
              <li>
                <span><i class="fas fa-phone-alt"></i></span>
                <p>Phone <span> <a href="tel:+923104511164">+923104511164</a></span></p>
              </li>
            </ul>
          </div>
          <div class="col-lg-2 col-sm-6">
            <h5>Company</h5>
            <ul class="footer-address-list link-hover pl-3">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#work">Work</a></li>
             
            </ul>
          </div>
      
        </div>
      </div>
    </div>
    {/* <div class="footer-brands">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 v-center">
            <h5 class="mb10">Top App Development Companies</h5>
            <p>News letter dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt. Enter your
              email</p>
          </div>
          <div class="col-lg-8 v-center">
            <ul class="footer-badges-">
              <li><a href="#"><img src="asset/images/about/badges-a.png" alt="badges"/></a></li>
              <li><a href="#"><img src="asset/images/about/badges-b.png" alt="badges"/></a></li>
              <li><a href="#"><img src="asset/images/about/badges-c.png" alt="badges"/></a></li>
              <li><a href="#"><img src="asset/images/about/badges-d.png" alt="badges"/></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div> */}
    <div class="footer-row3">
      <div class="copyright">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="footer-social-media-icons">
                <a href="" target="blank"><i class="fab fa-facebook"></i></a>
                <a href="" target="blank"><i class="fab fa-twitter"></i></a>
                <a href="" target="blank"><i class="fab fa-instagram"></i></a>
                <a href="" target="blank"><i class="fab fa-linkedin"></i></a>
                <a href="" target="blank"><i class="fab fa-youtube"></i></a>
                <a href="" target="blank"><i class="fab fa-pinterest-p"></i></a>  
                <a href="" target="blank"><i class="fab fa-vimeo-v"></i></a>
                <a href="" target="blank"><i class="fab fa-dribbble"></i></a>
                <a href="" target="blank"><i class="fab fa-behance"></i></a>
              </div>
              <div class="footer-">
                <p>Copyright &copy; <script>2022</script> EyeDev Allright Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>

    </div>
 
  );
}

export default App;
